import { render, staticRenderFns } from "./JoiningApplicationEducationalTable.vue?vue&type=template&id=3634f72e&"
import script from "./JoiningApplicationEducationalTable.vue?vue&type=script&lang=js&"
export * from "./JoiningApplicationEducationalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports